function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["id", "type", "name", "value", "className", "isDisabled", "isReadOnly", "placeholder", "onChange", "onKeyPress", "onFocus", "onBlur", "required", "minLength", "maxLength", "autoFocus", "dataSpacer", "hasRightIcon", "hasLeftIcon", "hasError", "min", "max", "autoComplete"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { forwardRef } from "react";
import classNamesMaker from "classnames";
import { getAuthorizedRestProps } from "#library/utils/propsUtil";
import styles from "./input.module.css";
export var Input = /*#__PURE__*/forwardRef(function (props, ref) {
  var id = props.id,
    _props$type = props.type,
    type = _props$type === void 0 ? "text" : _props$type,
    _props$name = props.name,
    name = _props$name === void 0 ? null : _props$name,
    _props$value = props.value,
    value = _props$value === void 0 ? "" : _props$value,
    _props$className = props.className,
    className = _props$className === void 0 ? "" : _props$className,
    _props$isDisabled = props.isDisabled,
    isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled,
    _props$isReadOnly = props.isReadOnly,
    isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? null : _props$placeholder,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? function () {
      return null;
    } : _props$onChange,
    _props$onKeyPress = props.onKeyPress,
    onKeyPress = _props$onKeyPress === void 0 ? function () {
      return null;
    } : _props$onKeyPress,
    _props$onFocus = props.onFocus,
    onFocus = _props$onFocus === void 0 ? function () {
      return null;
    } : _props$onFocus,
    _props$onBlur = props.onBlur,
    onBlur = _props$onBlur === void 0 ? function () {
      return null;
    } : _props$onBlur,
    _props$required = props.required,
    required = _props$required === void 0 ? true : _props$required,
    minLength = props.minLength,
    maxLength = props.maxLength,
    _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
    _props$dataSpacer = props.dataSpacer,
    dataSpacer = _props$dataSpacer === void 0 ? "" : _props$dataSpacer,
    _props$hasRightIcon = props.hasRightIcon,
    hasRightIcon = _props$hasRightIcon === void 0 ? false : _props$hasRightIcon,
    _props$hasLeftIcon = props.hasLeftIcon,
    hasLeftIcon = _props$hasLeftIcon === void 0 ? false : _props$hasLeftIcon,
    _props$hasError = props.hasError,
    hasError = _props$hasError === void 0 ? false : _props$hasError,
    _props$min = props.min,
    min = _props$min === void 0 ? undefined : _props$min,
    _props$max = props.max,
    max = _props$max === void 0 ? undefined : _props$max,
    _props$autoComplete = props.autoComplete,
    autoComplete = _props$autoComplete === void 0 ? undefined : _props$autoComplete,
    restProps = _objectWithoutProperties(props, _excluded);
  var customAttributes = _objectSpread({}, dataSpacer && dataSpacer.length > 0 && {
    "data-spacer": dataSpacer
  });
  var customClassNames = classNamesMaker(styles["jds-Input"], _defineProperty({}, styles["jds-Input--rightIcon"], hasRightIcon), _defineProperty({}, styles["jds-Input--leftIcon"], hasLeftIcon), _defineProperty({}, styles["jds-Input--active"], !!placeholder || typeof value === "string" && value.trim()), _defineProperty({}, styles["jds-Input--hasError"], hasError), className);
  return /*#__PURE__*/React.createElement("input", _extends({}, getAuthorizedRestProps(restProps), {
    ref: ref,
    className: customClassNames,
    id: id,
    name: name || id,
    type: type,
    onChange: onChange,
    onKeyPress: onKeyPress,
    onFocus: onFocus,
    onBlur: onBlur,
    value: value,
    min: min,
    max: max
  }, placeholder && {
    placeholder: placeholder
  }, isDisabled && {
    disabled: isDisabled
  }, isReadOnly && {
    readonly: isReadOnly
  }, required && {
    required: required
  }, minLength && {
    minLength: minLength
  }, maxLength && {
    maxLength: maxLength
  }, autoFocus && {
    autoFocus: autoFocus
  }, autoComplete && {
    autoComplete: autoComplete
  }, customAttributes));
});
Input.displayName = "Input";